import { __decorate } from "tslib";
import { AnyDecoder, AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { SimpleError } from '@simonbackx/simple-errors';
/**
 * The full content of an email or email template in a single language.
 * html and text are derived from the editor json, so they always belong together as a set.
 */
export class EmailContent extends AutoEncoder {
    subject = '';
    /**
     * Template converted to HTML, with the {{replacements}} still in place
     */
    html = '';
    text = '';
    /**
     * Raw editor json used to edit the content
     */
    json = {};
}
__decorate([
    field({ decoder: StringDecoder })
], EmailContent.prototype, "subject", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EmailContent.prototype, "html", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EmailContent.prototype, "text", void 0);
__decorate([
    field({ decoder: AnyDecoder })
], EmailContent.prototype, "json", void 0);
/**
 * Strict language selection: only searches the provided translations map and falls back to
 * the default content (which holds the default language when one is set). It never falls back
 * to a different template (level), so the content always stays correct — better correct content
 * in the wrong language than wrong content in the right language.
 */
export function getEmailContentForLanguage(defaultContent, translations, language) {
    if (language !== null) {
        const translated = translations.get(language);
        if (translated) {
            return translated;
        }
    }
    return defaultContent;
}
/**
 * An email or email template only supports these states:
 * 1. Untranslated: no language set and no translations
 * 2. One language: language set, no translations (the default content is that language)
 * 3. Multiple languages: language set, the default content holds that language and
 *    translations hold every other language — never the default language itself
 */
export function validateEmailTranslations({ language, translations }) {
    if (language === null && translations.size > 0) {
        throw new SimpleError({
            code: 'invalid_translations',
            message: 'Translations require a default language',
            human: $t('%ZeG'),
            field: 'translations',
        });
    }
    if (language !== null && translations.has(language)) {
        throw new SimpleError({
            code: 'invalid_translations',
            message: 'Translations cannot contain the default language',
            human: $t('%Ze2'),
            field: 'translations',
        });
    }
}
//# sourceMappingURL=EmailContent.js.map